import { Button, InputGroup, FormControl } from 'react-bootstrap'
import Modal from 'components/Modal/Modal'
import IconSelector from 'components/Form/Helpers/IconSelector/IconSelector'
import { ReactComponent as PetitGarage } from 'assets/default/svg/calculator/petitgarage.svg'
import { ReactComponent as MoyenGarage } from 'assets/default/svg/calculator/garagemoyen.svg'
import { ReactComponent as GrandGarage } from 'assets/default/svg/calculator/grandgarage.svg'
import { ReactComponent as PersoGarage } from 'assets/default/svg/calculator/garagetailleperso.svg'
import {
  initGarageSpace,
  showCalculator,
  initLabelGarage,
} from 'redux/features/bienAVendre/slice'
import { useAppSelector, useAppDispatch } from 'redux/hooks'
import {
  makeSelectGarageSpace,
  makeSelectLabelGarage,
  makeSelectShowedCalculator,
} from 'redux/features/bienAVendre/selectors'
import styles from './GarageSize.module.scss'

interface Props {
  onContinueButtonClick: () => void
  onBackButtonClick: () => void
}

const GarageSize = ({
  onContinueButtonClick,
  onBackButtonClick,
}: Props): JSX.Element => {
  const showedCalculator = useAppSelector(makeSelectShowedCalculator)
  const garageSpace = useAppSelector(makeSelectGarageSpace)
  const labelGarage = useAppSelector(makeSelectLabelGarage)
  const dispatch = useAppDispatch()

  const onChangeLabelGarage = (value: string | number | boolean | null) => {
    dispatch(initLabelGarage(value as number))
    dispatch(initGarageSpace(value as number))
  }

  const onChangeGarageCustomSize = (value: number) => {
    dispatch(initGarageSpace(value))
  }

  return (
    <Modal
      show={showedCalculator}
      title="Calculateur avancé de l'emprise au sol estimée"
      body={
        <div className={styles.garageSize}>
          <h1 className={styles.title}>Quelle est la taille de ce garage?</h1>

          <IconSelector
            onChange={onChangeLabelGarage}
            value={labelGarage}
            options={[
              {
                icon: <PetitGarage />,
                label: 'Petit (15m²)',
                value: 15,
              },
              {
                icon: <MoyenGarage />,
                label: 'Moyen (22m²)',
                value: 22,
              },
              {
                icon: <GrandGarage />,
                label: 'Grand (36m²)',
                value: 36,
              },
              {
                icon: <PersoGarage />,
                label: 'Valeur personnalisée',
                value: 0,
              },
            ]}
          />
          <p className={styles.helperText}>
            Vous ne savez pas&nbsp;? Choisissez «&nbsp;Grand&nbsp;» pour
            optimiser vos chances de trouver&nbsp;!
          </p>

          {labelGarage === 0 ? (
            <InputGroup className={styles.inputGarage}>
              <FormControl
                type="number"
                className={styles.formControl}
                onChange={(e) => {
                  if (!Number.isNaN(e.target.value) && e.target.value !== '') {
                    onChangeGarageCustomSize(parseInt(e.target.value, 10))
                  } else {
                    onChangeGarageCustomSize(0)
                  }
                }}
                value={garageSpace}
              />
              <InputGroup.Text id="inputGroup-sizing-sm">m²</InputGroup.Text>
            </InputGroup>
          ) : null}
        </div>
      }
      footer={
        <>
          <Button variant="outline-primary" onClick={onBackButtonClick}>
            Précédent
          </Button>
          <Button
            variant="primary"
            onClick={onContinueButtonClick}
            disabled={labelGarage === null}
          >
            Continuer
          </Button>
        </>
      }
      onCloseButtonClick={() => dispatch(showCalculator(false))}
    />
  )
}

export default GarageSize
